import * as React from 'react';
import NodeQuery from '../../../../QueryComponents/NodeQuery/NodeQuery';
import { IClientBusinessModel } from '../../../../../Types/ClientModelTypes';
import { ModelContext } from '../../../../../Model/ModelContext/ModelContext';
import BusinessValuePair from '../../../../../Features/Delsystem/_Common/Components/BusinessCollectionComponents/BusinessDataGrid/BusinessValuePair';
import { IColumnDef } from '../../../../../Types/ColumnDefType';

interface IProps {
  collection: IClientBusinessModel;
  /** Dot delimited path to the attribute, can also be just the attribute name.
   Should always end on an attribute name (ex: associationName1.associationName2.attributeName) */
  columndef: IColumnDef;
  objectId: string | null;
}

/**
 * Titel-värde par med värden hämtade från ett attribut i collection.
 */
class ConnectedListField extends React.Component<IProps> {
  static contextType = ModelContext;
  declare context: React.ContextType<typeof ModelContext>;

  render() {
    return (
      <NodeQuery
        key={this.props.columndef.attributeDef}
        collectionName={this.props.collection.CollectionName}
        id={this.props.objectId}
        fieldDefs={[this.props.columndef.attributeDef]}
      >
        {(loading, data) => {
          if (data) {
            return (
              <BusinessValuePair
                column={this.props.columndef}
                item={data as { id: string; _version: number }}
                collection={this.props.collection}
              />
            );
          }

          return null;
        }}
      </NodeQuery>
    );
  }
}

export default ConnectedListField;
